export default __webpack_public_path__ + "static/media/Gerber Dark.3c241de6.svg";